import { render, staticRenderFns } from "./HotelReservationInfo.vue?vue&type=template&id=a24bf0b8&"
import script from "./HotelReservationInfo.vue?vue&type=script&lang=js&"
export * from "./HotelReservationInfo.vue?vue&type=script&lang=js&"
import style0 from "./HotelReservationInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports